import { render, staticRenderFns } from "./IncomingActItems.vue?vue&type=template&id=fa8f6a8e"
import script from "./IncomingActItems.vue?vue&type=script&lang=js"
export * from "./IncomingActItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports